import React, { useEffect, useState } from 'react'
import { Outlet } from "react-router-dom";

const NonAuthLayout = ({ children }: any) => {
    const [layoutModeType, setLayoutModeType] = useState("light");
    const [layoutThemeType, setLayoutThemeType] = useState("default");
    
    useEffect(() => {
        // Get saved theme from localStorage
        const savedMode = localStorage.getItem("layoutMode");
        if (savedMode) {
            setLayoutModeType(savedMode);
        }
    }, []);

    useEffect(() => {
        document.documentElement.setAttribute("data-theme", layoutThemeType);
        if (layoutModeType === "dark") {
            document.documentElement.setAttribute("data-bs-theme", "dark");
        } else {
            document.documentElement.setAttribute("data-bs-theme", "light");
        }
        return () => {
            document.documentElement.removeAttribute("data-bs-theme");
            document.documentElement.removeAttribute("data-theme");
        };
    }, [layoutModeType, layoutThemeType]);
    
    return <Outlet />;
}
export default NonAuthLayout